import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { AccordionItem as m, AccordionTrigger as d, AccordionContent as i } from "@tameeni/ui";
import { cn as h } from "@tameeni/shared-logic";
const f = ({
  title: c,
  links: s,
  isMobile: o
}) => {
  const l = s.length > 5, a = () => /* @__PURE__ */ e(
    "ul",
    {
      className: h(
        o ? "space-y-4 ps-0" : "lg:space-y-3",
        l && !o ? "grid grid-cols-2 gap-x-4" : "flex flex-col"
      ),
      children: s.map((r, n) => /* @__PURE__ */ t("li", { className: "flex items-center gap-2", children: [
        r.icon && /* @__PURE__ */ e("span", { className: "text-gray-600 h-4 w-4", children: r.icon }),
        /* @__PURE__ */ e(
          "a",
          {
            href: r.url,
            className: "text-gray-600 hover:text-gray-900 text-xs",
            children: r.label
          }
        )
      ] }, n))
    }
  );
  return o ? /* @__PURE__ */ t(m, { value: c.toLowerCase(), className: "border-b-0", children: [
    /* @__PURE__ */ e(d, { className: "text-sm font-bold text-gray-800 hover:no-underline py-2 mb-2", children: c }),
    /* @__PURE__ */ e(i, { children: a() })
  ] }) : /* @__PURE__ */ t("div", { className: "mb-8 lg:mb-0 me-4", children: [
    /* @__PURE__ */ e("h5", { className: "font-bold text-gray-800 mb-2 lg:mb-5 text-sm", children: c }),
    a()
  ] });
};
export {
  f as FooterItem
};
//# sourceMappingURL=footer-item.js.map
